<ui-subnav-item value="Overview" link="/operations/overview" icon="griddy-checkbox" />

@if (showMyBusiness$ | async; as showMyBusiness) {
  @if (showMyBusiness.hasAccess || showMyBusiness.showUpsell) {
    <ui-subnav-item
      value="My business"
      link="/operations/my-business/businesses"
      icon="griddy-briefcase-alt"
      [badgeText]="showMyBusiness.showUpsell ? 'Mogul' : null" />
  }

  @if ((showMyBusinessSubItems$ | async) === true || (deviceDetectionService.$isMobile | async)) {
    <ui-subnav-item value="Businesses" link="/operations/my-business/businesses" variant="child" />
    <ui-subnav-item value="Reports" link="/operations/my-business/reports/profit-and-loss" variant="child" />
    <ui-subnav-item value="Transactions" link="/operations/my-business/transactions" variant="child" />
    <ui-subnav-item value="Adjustments" link="/operations/my-business/adjustments" variant="child" />
  }
}

@if (showOwnerStatements$ | async; as showOwnerStatements) {
  @if (showOwnerStatements.hasAccess || showOwnerStatements.showUpsell) {
    <ui-subnav-item
      value="Owner management"
      link="/operations/statements"
      icon="griddy-meet-and-greet"
      [badgeText]="showOwnerStatements.showUpsell ? 'Mogul' : null" />
  }

  @if ((showOwnerStatementsSubItems$ | async) === true || (deviceDetectionService.$isMobile | async)) {
    <ui-subnav-item value="Statements" link="/operations/statements" variant="child" />

    @if (showMyBusiness$ | async; as showMyBusiness) {
      @if (!showMyBusiness.hasAccessToBusiness) {
        <ui-subnav-item value="Transactions" link="/operations/my-business/transactions" variant="child" />
        <ui-subnav-item value="Adjustments" link="/operations/my-business/adjustments" variant="child" />
      }
    }

    <ui-subnav-item value="Owners" link="/operations/statements/owners" variant="child" />
    <ui-subnav-item value="Reservation commissions" link="/operations/statements/commissions" variant="child" />
    <ui-subnav-item value="Properties" link="/operations/statements/setup" variant="child" />

    @if (showOwnerStatements.hasAccess || showOwnerStatements.showUpsell) {
      <ui-subnav-item value="Accounting" link="/operations/statements/accounting" variant="child" />
    }
  }
}

<ui-subnav-item value="Task rules" link="/operations/task-rules" icon="griddy-clipboard-list" />

<ui-subnav-item value="Teammates" link="/operations/team" icon="griddy-users-event" />

@if (perms$.hasAccessTo(Features.PERM_TASKS_UPDATE_ALL) | async) {
  <ui-subnav-item value="Task calendar" link="/calendar/tasks" icon="griddy-calendar-time" />
}

<ui-subnav-item value="Notification rules" link="/operations/notifications" icon="griddy-notification" />
@if ((showNotificationRulesSubItems$ | async) === true || (deviceDetectionService.$isMobile | async)) {
  <section>
    <ui-subnav-item
      value="Instant notifications"
      link="/operations/notifications/segments/298427e9-47e0-4903-ba74-4b92b8395256"
      variant="child" />
    <ui-subnav-item
      value="Reminders"
      link="/operations/notifications/segments/4a7f629a-0196-47c1-8903-ad7c91323bed"
      variant="child" />
    <ui-subnav-item
      value="Task notifications"
      link="/operations/notifications/segments/36e9be23-c98a-40e7-aaf6-e8520ce61ef5"
      variant="child" />
  </section>
}

<ui-subnav-item value="Log" link="/operations/log" icon="griddy-console" />
